module.exports = {"validation":{"required":"This value is required","email":"Invalid email address"}}